<template>
  <v-container fluid>
    <user-invitation-dialog
      :invitation-dialog="invitationDialog"
      @close-dialog="invitationDialog = false"
      @invite-user="inviteWriter"
    />
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <h2 class="title mb-3">ライター一覧</h2>
        <v-btn color="primary" dark tile @click="invitationDialog = true">
          新規ライター招待
        </v-btn>
        <UserIndexTable :users="writers" :admin-table="false" @reinvite-user-auth="reinviteUserAuth" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import UserInvitationDialog from '@/components/commons/UserInvitationDialog'
import UserIndexTable from '@/components/commons/UserIndexTable'
import headUtilsMixin from '@/mixins/head_utils'
import { mapState } from 'vuex'
import { deserialize } from 'deserialize-json-api'

export default {
  components: {
    UserInvitationDialog,
    UserIndexTable
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: 'ライターユーザー一覧',
      page: 1,
      invitationDialog: false,
      writers: []
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.UserStore.currentUser
    })
  },
  mounted: function () {
    this.fetchWriters()
  },
  methods: {
    fetchWriters () {
      const params = { params: { role: 'writer' } }
      axios.get('/api/users', params).then(
        ({ data }) => {
          this.writers = deserialize(data).data
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.errors.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },
    showInvitationDialog () {
      this.invitationAddress = null
      this.invitationDialog = true
    },
    inviteWriter (address) {
      const query = {
        email: address
      }
      this.$store.dispatch('LoaderStore/displayLoader')
      axios.post('/api/writers/invitations', query).then(
        () => {
          this.fetchWriters()
          this.$store.dispatch('LoaderStore/hideLoader')
          const payload = {
            status: 200,
            message: '招待メールを送信しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },
    reinviteUserAuth (userAuthId) {
      if (!confirm('招待メールを送信してよろしいでしょうか？')) return

      axios.patch(`/api/writers/${userAuthId}/invitations`).then(
        () => {
          const payload = {
            status: 200,
            message: '招待メールを送信しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    }
  }
}
</script>
